import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { ApplicationState, AppState } from '../../../../store';
import { withSnackbar, ProviderContext } from 'notistack';
import {
  OrganizationCaseType,
  OrganizationCaseTypeStep
} from '../../../../interfaces/Organization';
import { ITranslatorService } from '../../../../services/Interfaces/ITranslatorService';
import { ApplicationContext, AppContext } from '../../../../context/Contexts';
import { IOrganizationService } from '../../../../services/Interfaces/IOrganizationService';
import { Box, Button, IconButton, Card, CardContent } from '@material-ui/core';
import { ScaleLoader } from 'react-spinners';
import MUIDataTable, {
  MUIDataTableColumnOptions,
  MUIDataTableMeta,
  SelectableRows
} from 'mui-datatables';
import moment from 'moment';
import { MUITranslations } from '../../../../helpers/MUITableTranslations';
import { RouteComponentProps } from 'react-router';
import { IReferential } from '../../../../interfaces/IReferential';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { IReferentialService } from '../../../../services/Interfaces/IReferentialService';
import Referentials from '../../../../helpers/Referentials.json';
import { ReferentialCode } from '../../../../helpers/Constants';
import DeleteOutlineTwoToneIcon from '@material-ui/icons/DeleteOutlineTwoTone';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';

interface IOrganizationCaseTypeStepState {
  organizationCaseTypeSteps: OrganizationCaseTypeStep[];
  isLoading: boolean;
  organizationCaseTypes: OrganizationCaseType[];
  organizationCaseStepTypes: IReferential[];
  selectedOrganizationCaseType: OrganizationCaseType | null;
  selectedOrganizationCaseStepType: IReferential | null;
  organizationId: number;
}

type IOrganizationCaseTypeStepProps = { appState: AppState } & ProviderContext &
  RouteComponentProps<{ id: string }>;

class OrganizationCaseTypeStepTab extends React.PureComponent<
  IOrganizationCaseTypeStepProps,
  IOrganizationCaseTypeStepState
> {
  private translatorService!: ITranslatorService;
  private organizationService!: IOrganizationService;
  private appReferentialService!: IReferentialService;

  static contextType = ApplicationContext;

  state = {
    organizationCaseTypeSteps: [],
    isLoading: false,
    organizationCaseTypes: [],
    organizationCaseStepTypes: [],
    selectedOrganizationCaseType: null,
    selectedOrganizationCaseStepType: null,
    organizationId: 0
  } as IOrganizationCaseTypeStepState;

  public componentDidMount() {
    const hoId = Number.parseInt(this.props.match.params.id);

    if (Number.isNaN(hoId)) {
      return;
    }

    this.setState(
      {
        isLoading: true
      },
      async () => {
        await this.loadOrganizationSteps(null);
      }
    );
  }

  loadOrganizationSteps = async (caseTypeId: number | null) => {
    const hoId = Number.parseInt(this.props.match.params.id);

    if (Number.isNaN(hoId)) {
      return;
    }
    const refCaseType = Referentials.referential.find(
      (item) => item.code === ReferentialCode.CaseType
    );
    const refSteps = Referentials.referential.find(
      (item) => item.code === ReferentialCode.NewCaseSteps
    );

    const [orgCaseList, orgCaseTypes, orgStepList, orgStepTypes] = await Promise.all([
      this.organizationService.GetOrganizationCaseType(hoId),
      this.appReferentialService.Get(refCaseType!.baseUrl),
      caseTypeId === null ? [] : this.organizationService.GetOrganizationCaseTypeStep(caseTypeId),
      this.appReferentialService.Get(refSteps!.baseUrl)
    ]);

    const orgCaseList1 = orgCaseList.map((item: OrganizationCaseType) => {
      item.caseType = orgCaseTypes.find(
        (caseType: IReferential) => caseType.id === item.caseTypeId
      )!;
      return item;
    });

    this.setState({
      organizationCaseTypeSteps: orgStepList.sort(function (a, b) {
        return a.order - b.order;
      }),
      organizationCaseTypes: orgCaseList1,
      organizationCaseStepTypes: orgStepTypes.filter((item) => item.isActive === true),
      isLoading: false,
      organizationId: hoId
    });
  };

  reloadOrganizationSteps = async (caseTypeId: number | null) => {
    const [orgStepList] = await Promise.all([
      caseTypeId === null ? [] : this.organizationService.GetOrganizationCaseTypeStep(caseTypeId)
    ]);

    this.setState({
      organizationCaseTypeSteps: orgStepList.sort(function (a, b) {
        return a.order - b.order;
      }),
      isLoading: false
    });
  };

  deleteOrgLevel = async (event: any, tableMeta: MUIDataTableMeta) => {
    try {
      const id = tableMeta.rowData[0];

      await this.organizationService.RemoveOrganizationCaseTypeStep(id);

      this.setState(
        {
          isLoading: true
        },
        () => {
          this.reloadOrganizationSteps(this.state.selectedOrganizationCaseType!.id);
        }
      );

      this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
        variant: 'success'
      });
    } catch (error) {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  };

  moveUp = async (event: any, tableMeta: MUIDataTableMeta) => {
    const id = tableMeta.rowData[0];
    const cloneArray = [...this.state.organizationCaseTypeSteps];
    const itemToMoveUpIndex = cloneArray.findIndex((item) => item.id === id);

    if (itemToMoveUpIndex === -1) {
      return;
    }
    if (cloneArray[itemToMoveUpIndex].order === 1) {
      return;
    }

    const itemToMoveDownIndex = cloneArray.findIndex(
      (item) => item.order === cloneArray[itemToMoveUpIndex].order - 1
    );

    cloneArray[itemToMoveUpIndex] = {
      ...cloneArray[itemToMoveUpIndex],
      order: cloneArray[itemToMoveUpIndex].order - 1
    };
    cloneArray[itemToMoveDownIndex] = {
      ...cloneArray[itemToMoveDownIndex],
      order: cloneArray[itemToMoveDownIndex].order + 1
    };

    try {
      await this.organizationService.UpdateOrganizationCaseTypeStep(cloneArray[itemToMoveUpIndex]);
      await this.organizationService.UpdateOrganizationCaseTypeStep(
        cloneArray[itemToMoveDownIndex]
      );

      this.setState({
        organizationCaseTypeSteps: cloneArray.sort(function (a, b) {
          return a.order - b.order;
        })
      });
      this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
        variant: 'success'
      });
    } catch (error) {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  };

  moveDown = async (event: any, tableMeta: MUIDataTableMeta) => {
    const id = tableMeta.rowData[0];
    const cloneArray = [...this.state.organizationCaseTypeSteps];
    const itemToMoveIndex = cloneArray.findIndex((item) => item.id === id);

    if (itemToMoveIndex === -1) {
      return;
    }
    if (cloneArray[itemToMoveIndex].order === cloneArray.length) {
      return;
    }

    const itemToMoveToIndex = cloneArray.findIndex(
      (item) => item.order === cloneArray[itemToMoveIndex].order + 1
    );

    cloneArray[itemToMoveIndex] = {
      ...cloneArray[itemToMoveIndex],
      order: cloneArray[itemToMoveIndex].order + 1
    };
    cloneArray[itemToMoveToIndex] = {
      ...cloneArray[itemToMoveToIndex],
      order: cloneArray[itemToMoveToIndex].order - 1
    };

    try {
      await this.organizationService.UpdateOrganizationCaseTypeStep(cloneArray[itemToMoveIndex]);
      await this.organizationService.UpdateOrganizationCaseTypeStep(cloneArray[itemToMoveToIndex]);

      this.setState({
        organizationCaseTypeSteps: cloneArray.sort(function (a, b) {
          return a.order - b.order;
        })
      });
      this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
        variant: 'success'
      });
    } catch (error) {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  };

  getColumns = () => {
    const columns = [
      {
        name: 'id',
        options: { display: 'excluded', filter: false } as MUIDataTableColumnOptions
      },
      {
        name: 'organizationStep',
        label: this.translatorService.Tranlate('ORGANIZATIONS_CASE_STEP_HEADER', 'Pas'),
        options: {
          sort: false,
          customBodyRender: (value: IReferential) => {
            return value ? value.displayName : '';
          }
        } as MUIDataTableColumnOptions
      },
      {
        name: 'dateModification',
        label: this.translatorService.Tranlate(
          'ORGANIZATIONS_DATE_MODIFICATION_HEADER',
          'Data Modificare'
        ),
        options: {
          sort: false,
          customBodyRender: (value: Date) =>
            moment.utc(value).local().format(this.props.appState.longDateFormat)
        } as MUIDataTableColumnOptions
      },
      {
        name: 'order',
        sortDirection: 'asc',
        label: this.translatorService.Tranlate('ORGANIZATION_CASE_STEP_ORDER_HEADER', 'Ord'),
        options: { sort: false }
      },
      {
        name: '',
        options: {
          setCellHeaderProps: () => ({ align: 'center' }),
          setCellProps: () => ({ align: 'center' }),
          sortOrder: {
            name: 'order',
            direction: 'asc'
          },
          customBodyRender: (value: boolean, tableMeta: MUIDataTableMeta) => {
            return (
              <Fragment>
                <IconButton color="inherit" size="small" onClick={(e) => this.moveUp(e, tableMeta)}>
                  <KeyboardArrowUpIcon />
                </IconButton>
                <IconButton
                  color="inherit"
                  size="small"
                  onClick={(e) => this.moveDown(e, tableMeta)}
                >
                  <KeyboardArrowDownIcon />
                </IconButton>
              </Fragment>
            );
          }
        }
      },
      {
        name: '',
        options: {
          setCellHeaderProps: () => ({ align: 'center' }),
          setCellProps: () => ({ align: 'center' }),
          customBodyRender: (value: boolean, tableMeta: MUIDataTableMeta) => {
            return (
              <IconButton
                aria-label="delete"
                color="inherit"
                className="text-danger"
                size="small"
                onClick={(e) => this.deleteOrgLevel(e, tableMeta)}
              >
                <DeleteOutlineTwoToneIcon />
              </IconButton>
            );
          }
        }
      }
    ];

    return columns;
  };

  addOrgStep = async () => {
    try {
      await this.organizationService.AddOrganizationCaseTypeStep({
        order: this.state.organizationCaseTypeSteps.length + 1,
        stepId: this.state.selectedOrganizationCaseStepType!.id,
        organizationCaseTypeId: this.state.selectedOrganizationCaseType!.id
      } as OrganizationCaseTypeStep);

      this.setState(
        {
          isLoading: true,
          selectedOrganizationCaseStepType: null
        },
        () => {
          this.reloadOrganizationSteps(this.state.selectedOrganizationCaseType!.id);
        }
      );

      this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
        variant: 'success'
      });
    } catch (error) {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  };

  handleAutocompleteCaseChange = (newValue: any | null) => {
    this.setState(
      {
        selectedOrganizationCaseType: newValue,
        isLoading: true
      },
      () => {
        this.reloadOrganizationSteps(newValue === null ? null : newValue.id);
      }
    );
  };

  handleAutocompleteStepChange = (newValue: IReferential | null) => {
    this.setState({ selectedOrganizationCaseStepType: newValue });
  };

  public renderAddForm() {
    return (
      <Box mt={1} pt={1}>
        <Card elevation={1}>
          <CardContent>
            <ValidatorForm onSubmit={this.addOrgStep}>
              <Autocomplete
                id="caseTypes"
                className="m-2"
                fullWidth
                options={this.state.organizationCaseTypes}
                value={this.state.selectedOrganizationCaseType}
                onChange={(e: any, newValue: OrganizationCaseType | null) =>
                  this.handleAutocompleteCaseChange(newValue)
                }
                getOptionLabel={(option: OrganizationCaseType) => option.caseType!.displayName}
                renderInput={(params) => (
                  <TextValidator
                    {...params}
                    name="organizationCaseTypes"
                    value={this.state.selectedOrganizationCaseType}
                    label={this.translatorService.Tranlate(
                      'ORGANIZATION_CASE_TYPE_LABEL',
                      'Tip dosar'
                    )}
                    fullWidth
                    validators={['required']}
                    errorMessages={[
                      this.translatorService.Tranlate(
                        'VALIDATORS_REQUIRED',
                        'Campul este obligatoriu'
                      )
                    ]}
                  />
                )}
              />

              <Autocomplete
                id="stepTypes"
                className="m-2"
                fullWidth
                options={this.state.organizationCaseStepTypes}
                value={this.state.selectedOrganizationCaseStepType}
                onChange={(e: any, newValue: IReferential | null) =>
                  this.handleAutocompleteStepChange(newValue)
                }
                getOptionLabel={(option: IReferential) => option.displayName}
                renderInput={(params) => (
                  <TextValidator
                    {...params}
                    name="organizationStepTypes"
                    value={this.state.selectedOrganizationCaseStepType}
                    label={this.translatorService.Tranlate('ORGANIZATION_STEP_TYPE_LABEL', 'Pas')}
                    fullWidth
                    validators={['required']}
                    errorMessages={[
                      this.translatorService.Tranlate(
                        'VALIDATORS_REQUIRED',
                        'Campul este obligatoriu'
                      )
                    ]}
                  />
                )}
              />

              <div className="text-right">
                <Button className="m-2" variant="contained" color="secondary" type="submit">
                  {this.translatorService.Tranlate('ADMIN_EDIT_USER_ROLES_BTN_ADD', 'ADAUGA')}
                </Button>
              </div>
            </ValidatorForm>
          </CardContent>
        </Card>
      </Box>
    );
  }

  public render() {
    this.translatorService = (this.context as AppContext).translatorService;
    this.organizationService = (this.context as AppContext).organizationService;
    this.appReferentialService = (this.context as AppContext).referentialService;

    const options = {
      filter: false,
      search: false,
      viewColumns: false,
      selectableRows: 'none' as SelectableRows,
      selectableRowsOnClick: false,
      print: false,
      download: false,
      textLabels: MUITranslations.GetTranslations(this.translatorService),
      elevation: 1
    };

    return (
      <Fragment>
        {this.renderAddForm()}
        <Box mt={1} pt={1}>
          <div className="d-flex flex-row text-center flex-wrap justify-content-center">
            <ScaleLoader color={'var(--primary)'} loading={this.state.isLoading} />
          </div>
          {!this.state.isLoading ? (
            <MUIDataTable
              title={''}
              data={this.state.organizationCaseTypeSteps}
              columns={this.getColumns()}
              options={options}
            />
          ) : null}
        </Box>
      </Fragment>
    );
  }
}

export default connect(
  (state: ApplicationState) => ({
    appState: state.app
  }),
  null
)(withSnackbar(OrganizationCaseTypeStepTab as any));
